import { NgModule } from '@angular/core';
import { ShopProductsComponent } from './components/shop-products/shop-products.component';
import { ShopProductComponent } from './components/shop-product/shop-product.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GeneralModule } from '../general/general.module';
import { ShopOrderComponent } from './components/shop-order/shop-order.component';
import { ShopOrderLineComponent } from './components/shop-order-line/shop-order-line.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InlineSVGModule } from 'ng-inline-svg';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    GeneralModule,
    FormsModule,
    FontAwesomeModule,
    InlineSVGModule,
  ],
  declarations: [
    ShopProductsComponent,
    ShopProductComponent,
    ShopOrderComponent,
    ShopOrderLineComponent,
  ],
  exports: [
    ShopProductsComponent,
    ShopProductComponent,
    ShopOrderComponent,
    ShopOrderLineComponent,
  ],
  providers: [
  ],
})
export class ShopModule { }
